import React from 'react'

import crowdrise from '../../assets/crowdrise.png'

const ncp = 'http://www.naturalcapitalpartners.com/solutions/solution/forests'
const oceans5 = 'http://oceans5.org/projects/'
const forestandsea = 'https://www.forestandsea.org/info/'

export const HouseholdPreamble = props => (
  <div className="payment-explanation">
    <div className="payment-explanation-header">File for your Household</div>
    <div className="payment-explanation-text">
      You have {props.multiplier} people living in your home. You can make an ever bigger contribution by choosing to
      offset the climate impact for your entire household.
    </div>
  </div>
)

export const MonthPreamble = (
  <div className="payment-explanation">
    <div className="payment-explanation-text">
      This contribution will completely offset your monthly climate impact through the purchase
      of certified carbon credits that are sourced from forest conservation projects in 3 continents.
    </div>
  </div>
)

export const YearPreamble = (
  <div className="payment-explanation">
    <div className="payment-explanation-header">Offset for the Year!</div>
    <div className="payment-explanation-text">
      Your can make an even bigger impact by giving a one-time annual voluntary tax, which allows us to get
      funding to vitally important forests and ocean ecosystems even more quickly.
    </div>
  </div>
)

export const Crowdrise = (
  <div>
    <span>Donations Management by</span>
    <img src={crowdrise} alt="crowdrise" className="payment-crowdrise"/>
  </div>
)

export const WhereGoes = props => (
  <div className="payment-buffered payment-explanation">
    <div className="payment-explanation-header">Where Does the Money Go?</div>
    <div className="payment-explanation-text">
      We have joined forces with <a className='payment-link' href={ncp} target="_blank" rel='noopener noreferrer'>Natural Capital Partners</a>,
      the leader in sourcing the highest level of certified carbon credits available.
      Additional revenue will go to supporting an array of key ocean conservation
      projects through our partner <a className='payment-link' href={oceans5} target="_blank" rel='noopener noreferrer'>Oceans 5</a>.
    </div>
    <a className="payment-btn payment-btn-link" href={forestandsea} target="_blank" rel='noopener noreferrer'>
      LEARN MORE
    </a>
  </div>
)



// WEBPACK FOOTER //
// ./src/apps/Payment/preambles.js